import React from 'react';
import { Link } from 'react-router-dom';
import { SvgIconComponent } from '@mui/icons-material';
import { Avatar, Card, CardActionArea, Grid, Typography } from '@mui/material';
import { ATTR } from '../../help/attrs';

interface LauncherCardProps {
    label: string;
    to: string;
    icon: SvgIconComponent;
    blurb?: string;
    /** Sub-page tiles are denser than module tiles so a 12-page module still reads at a glance. */
    dense?: boolean;
    /** Help-mode key for the tile (from the catalog's `helpKey`). */
    helpTag?: string;
}

/** One tile on the launcher — a module on /modules, a page on /modules/:key. */
const LauncherCard = ({ label, to, icon: Icon, blurb, dense = false, helpTag }: LauncherCardProps) => (
    <Grid size={dense ? { xs: 12, sm: 6, md: 3 } : { xs: 12, sm: 6, md: 4, lg: 3 }} {...(helpTag ? { [ATTR.element]: helpTag } : {})}>
        <Card
            variant="outlined"
            sx={{
                height: '100%',
                borderRadius: 2,
                transition: 'box-shadow .2s ease, transform .2s ease',
                '&:hover': { boxShadow: 4, transform: 'translateY(-2px)' },
            }}
        >
            <CardActionArea
                component={Link}
                to={to}
                sx={{
                    height: '100%',
                    p: dense ? 2 : 3,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                }}
            >
                <Avatar
                    sx={{
                        width: dense ? 40 : 56,
                        height: dense ? 40 : 56,
                        bgcolor: 'primary.main',
                        mb: dense ? 1 : 1.5,
                    }}
                >
                    <Icon fontSize={dense ? 'small' : 'medium'} />
                </Avatar>
                <Typography variant="h6" sx={{ fontSize: dense ? '0.9rem' : '1rem', fontWeight: 600 }}>
                    {label}
                </Typography>
                {blurb && (
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                        {blurb}
                    </Typography>
                )}
            </CardActionArea>
        </Card>
    </Grid>
);

export default LauncherCard;
